import { Routes } from '@angular/router';

import { loginRedirectGuard } from './guards/login-redirect.guard';
import { authGuard } from './guards/auth.guard';
import { Roles } from './models/Enums/Roles';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Dashboard',
    },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./core/components/login/login.component').then((m) => m.LoginComponent),
    canActivate: [loginRedirectGuard],
  },
  //   {
  //     path: 'user-confirmation',
  //     component: UserConfirmationComponent,
  //   },
  //   {
  //     path: 'forgot-password',
  //     component: ForgotPasswordComponent,
  //   },
  {
    path: 'orders',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/orders/orders.component').then((m) => m.OrdersComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Orders',
    },
  },
  {
    path: 'orders/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/orders/add-edit-order/order-details/order-details.component').then(
        (m) => m.OrderDetailsComponent,
      ),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Orders',
      hidden: true,
    },
  },
  {
    path: 'transfers',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/transfers/list/list.component').then((m) => m.TransfersListComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Transfers',
    },
  },
  {
    path: 'transfers/:billOfLading/:transferStatus',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/transfers/add-edit-transfer/add-edit-transfer.component').then(
        (m) => m.AddEditTransferComponent,
      ),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Transfers',
      hidden: true,
    },
  },
  {
    path: 'accounts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/accounts/list/accounts.component').then((m) => m.AccountsComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Accounts',
    },
  },
  {
    path: 'accounts/:id/:accno',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/accounts/view/view.component').then((m) => m.ViewAccountInfoComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Accounts',
      hidden: true,
    },
  },
  {
    path: 'conditioners',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/conditioners/conditioners.component').then((m) => m.ConditionersComponent),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Conditioners',
    },
  },
  {
    path: 'available-hybrids',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/available-hybrids/available-hybrids.component').then(
        (m) => m.AvailableHybridsComponent,
      ),
    data: {
      roles: [Roles.ISR, Roles.RSA, Roles.SalesSupport, Roles.SalesAdmin, Roles.DivisionManager],
      title: 'Avail. Hybrids',
    },
  },
];
